import defaultColors from "./defaultColors";

const findColor = (colors, subtype) =>
  colors.find((color) => color.subtype === subtype);

/**
 * Resolves the display color for a tag subtype. Falls back to the default
 * palette while tag colors are loading or when the event uses defaults.
 */
export const getTagColor = (tagColors, subtype) => {
  if (!tagColors || tagColors.data === "default") {
    return findColor(defaultColors, subtype);
  }
  return findColor(tagColors, subtype) || findColor(defaultColors, subtype);
};
